import React, { useId, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { FaqItem } from '../../types/content';
type AccordionProps = {
  items: FaqItem[];
  defaultOpen?: number;
};
export function Accordion({
  items,
  defaultOpen
}: AccordionProps) {
  const [open, setOpen] = useState<number[]>(defaultOpen !== undefined ? [defaultOpen] : []);
  const baseId = useId();
  const toggle = (i: number) => setOpen(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);
  return <div className="divide-y divide-line border-y border-line" data-id="element-478" data-mp="3h1b21qhycz33">
      {items.map((item, i) => {
      const isOpen = open.includes(i);
      const panelId = `${baseId}-panel-${i}`;
      const buttonId = `${baseId}-button-${i}`;
      return <div key={item.q} data-id="element-479" data-mp="3uy6m0dzqsaxx" data-mpi={i}>
            <h3 data-id="element-480" data-mp="3ux50ffl3o61y">
              <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => toggle(i)} className="flex w-full items-center justify-between gap-6 py-5 text-left text-[17px] font-medium text-ink transition-colors duration-150 hover:text-royal" data-id="element-481" data-mp="3uxeupfd6gzdg">
                {item.q}
                <PlusIcon className={`h-5 w-5 shrink-0 text-gold-700 transition-transform duration-200 ease-premium ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-482" data-mp="36wmp9raqkx75" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-483" data-mp="3glwjbcp54pxw">
              {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-484" data-mp="3ukmg0r81snlq">
                  <p className="max-w-3xl pb-6 leading-relaxed text-muted" data-id="element-485" data-mp="3vdfidgga8xf1">{item.a}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}